













































import { Component, Prop, Inject, Vue } from 'vue-property-decorator';
import { Validator } from 'vee-validate';

import Typography from '@/components/atoms/Typography/Typography.vue';

@Component({
  components: { Typography },
  $_veeValidate: {
    value() {
      const { value } = this as any;
      return value;
    },
    name() {
      const { name } = this as any;
      return name;
    }
  }
})
export default class TextField extends Vue {
  @Inject('$validator') public $validator!: Validator;

  @Prop(String) readonly value!: string;
  @Prop(String) readonly name!: string;
  @Prop(String) readonly label!: string;
  @Prop(String) readonly rightText?: string;
  @Prop(String) readonly placeholder!: string;
  @Prop(String) readonly maxlength?: string;
  @Prop(String) readonly tippy?: string;
  @Prop(Boolean) readonly readonly?: boolean;
  @Prop({ default: false }) readonly error!: boolean;
  @Prop({ default: false }) readonly optional?: boolean;
  @Prop({ default: false }) readonly autofocus?: boolean;

  updateValue(value: string, event: any) {
    if (this.maxlength) {
      const newValue = value.substr(0, +this.maxlength);
      event.target.value = newValue;
      this.$emit('input', newValue);
    } else {
      this.$emit('input', value);
    }
  }
}
